module.exports = __webpack_public_path__ + "static/media/users.eca140a3.svg";